<script setup lang="ts">
import Button from '@satch-ui/components/button/Button.vue'
import clsx from 'clsx'

import { HeartGrayIcon, HeartRedIcon } from '@fond-of/satch-icons'

const props = defineProps<{
  isActive: boolean
  pdp?: boolean
}>()
</script>

<template>
  <Button
    :class="
      clsx('pointer-events-auto min-h-0 border-none bg-transparent', {
        'relative ml-4': props.pdp,
        'absolute z-[10]': !props.pdp,
      })
    "
    :variant="null"
    :padding="null"
    size="icon"
  >
    <div
      class="relative flex items-center justify-center"
      :class="{
        'size-[34px]': props.pdp,
        'size-[20px] md:size-[30px]': !props.pdp,
      }"
    >
      <HeartRedIcon
        class="absolute w-full transition-all duration-300"
        :class="{
          'scale-100 opacity-100': props.isActive,
          'scale-50 opacity-0': !props.isActive,
        }"
      />

      <HeartGrayIcon
        class="absolute w-full transition-all duration-300"
        :class="{
          'scale-50 opacity-0': props.isActive,
          'scale-100 opacity-100': !props.isActive,
        }"
      />
    </div>
  </Button>
</template>
